import app from 'flarum/forum/app';
const url = path => app.forum.attribute('apiUrl') + '/parley/calls' + path;
const quiet = {
  background: true,
  errorHandler: () => {}
};
export default {
  start: (conversationId, kind) => app.request({
    method: 'POST',
    url: url(''),
    body: {
      conversationId,
      kind
    }
  }),
  current: () => app.request({
    method: 'GET',
    url: url('/current'),
    ...quiet
  }),
  ice: () => app.request({
    method: 'GET',
    url: url('/ice')
  }),
  accept: id => app.request({
    method: 'POST',
    url: url(`/${id}/accept`)
  }),
  decline: id => app.request({
    method: 'POST',
    url: url(`/${id}/decline`),
    ...quiet
  }),
  end: id => app.request({
    method: 'POST',
    url: url(`/${id}/end`),
    ...quiet
  }),
  fail: id => app.request({
    method: 'POST',
    url: url(`/${id}/fail`),
    ...quiet
  }),
  ping: (id, relayed) => app.request({
    method: 'POST',
    url: url(`/${id}/ping`),
    body: {
      relayed
    },
    ...quiet
  }),
  signal: (id, type, data) => app.request({
    method: 'POST',
    url: url(`/${id}/signal`),
    body: {
      type,
      data
    },
    ...quiet
  }),
  signals: (id, after) => app.request({
    method: 'GET',
    url: url(`/${id}/signals?after=${after}`),
    ...quiet
  }),
  usage: () => app.request({
    method: 'GET',
    url: url('/usage')
  }),
  /** Hang up from a page that is closing: a beacon outlives the page. */
  beaconEnd(id) {
    const data = new FormData();
    data.append('csrfToken', app.session.csrfToken);
    navigator.sendBeacon?.(url(`/${id}/end`), data);
  }
};
const vurl = path => app.forum.attribute('apiUrl') + '/parley/voice' + path;

/** Voice chat in rooms. */
export const voiceApi = {
  current: () => app.request({
    method: 'GET',
    url: vurl('/current'),
    ...quiet
  }),
  roster: room => app.request({
    method: 'GET',
    url: vurl(`/${room}`),
    ...quiet
  }),
  join: room => app.request({
    method: 'POST',
    url: vurl(`/${room}/join`)
  }),
  leave: room => app.request({
    method: 'POST',
    url: vurl(`/${room}/leave`),
    ...quiet
  }),
  ping: (room, muted) => app.request({
    method: 'POST',
    url: vurl(`/${room}/ping`),
    body: {
      muted
    },
    ...quiet
  }),
  signal: (room, to, type, data) => app.request({
    method: 'POST',
    url: vurl(`/${room}/signal`),
    body: {
      to,
      type,
      data
    },
    ...quiet
  }),
  signals: (room, after) => app.request({
    method: 'GET',
    url: vurl(`/${room}/signals?after=${after}`),
    ...quiet
  }),
  beaconLeave(room) {
    const data = new FormData();
    data.append('csrfToken', app.session.csrfToken);
    navigator.sendBeacon?.(vurl(`/${room}/leave`), data);
  }
};